import React from 'react'
import { ThemeToggle } from '../../components/ui'
import { useUser } from '../../contexts/UserContext'

const VendorSettings: React.FC = () => {
  const { user, loading } = useUser()

  if (loading) {
    return (
      <div className="p-8">
        <div className="max-w-4xl mx-auto">
          <p className="text-muted-foreground">Loading settings...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return (
      <div className="p-8">
        <div className="max-w-4xl mx-auto">
          <p className="text-muted-foreground">Unable to load user data</p>
        </div>
      </div>
    )
  }

  return (
    <div className="p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-foreground mb-2">
          Settings
        </h1>
        <p className="text-muted-foreground mb-8">
          Manage your account settings and preferences
        </p>

        <div className="space-y-6">
          {/* Profile Information */}
          <div className="bg-card border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold text-foreground mb-4">
              Profile Information
            </h2>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-card-foreground mb-2">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-input rounded-lg bg-background text-foreground"
                    defaultValue={user.first_name}
                    placeholder="First name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-card-foreground mb-2">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-input rounded-lg bg-background text-foreground"
                    defaultValue={user.last_name}
                    placeholder="Last name"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-card-foreground mb-2">
                  Email
                </label>
                <input
                  type="email"
                  className="w-full px-3 py-2 border border-input rounded-lg bg-background text-foreground"
                  defaultValue={user.email}
                  placeholder="email@example.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-card-foreground mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  className="w-full px-3 py-2 border border-input rounded-lg bg-background text-foreground"
                  defaultValue={user.phone}
                  placeholder="+1 (555) 123-4567"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-card-foreground mb-2">
                  Organization
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-input rounded-lg bg-background text-foreground"
                  value={user.organization || ''}
                  disabled
                />
              </div>
            </div>
          </div>

          {/* Appearance */}
          <div className="bg-card border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold text-foreground mb-4">
              Appearance
            </h2>
            <div className="flex items-center justify-between">
              <div>
                <label className="block text-sm font-medium text-card-foreground mb-1">
                  Theme
                </label>
                <p className="text-xs text-muted-foreground">
                  Toggle between light and dark mode
                </p>
              </div>
              <ThemeToggle />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-3">
            <button className="px-4 py-2 border border-input rounded-lg text-card-foreground hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
              Cancel
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VendorSettings
